<div *ngIf="productCategoriesForm">
<div class="container-fluid">
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="my-2">
          <mat-label class="med-world-basic-font med-world-basic-font__medium secondary_black_color">Select Category <span class="text-danger">*</span></mat-label>
        </div>
        <div>
          <mat-form-field appearance="outline" class="w-100 input-font equipment" 
          [class.equipment_increase]="productCategoriesForm?.value.length > 4"
          (click)="categoryInputFieldClicked()">
        
          <!-- Selected Categories as Chips -->
          <mat-chip-listbox *ngIf="productCategoriesForm?.value.length">
            <mat-chip class="chip" *ngFor="let category of productCategoriesForm?.value; let i = index" 
              [removable]="true" (removed)="remove(i)">
              {{ getCategory(category) }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
          </mat-chip-listbox>
        
          <!-- Search Input Field -->
          <input type="text" matInput
            placeholder="Search for category"
            (input)="filterCategory($event)" (focus)="isCategoryInputFieldClicked = true">
        </mat-form-field>
        <div class="category-drop-down" *ngIf="!noRecordsFoundData && isCategoryInputFieldClicked">
          <div *ngFor="let category of filteredCategory" class="mat-option-data custom-option" (click)="toggleCheckbox(category)">
            <mat-checkbox [checked]="isSelected(category.id)">
            </mat-checkbox>
            <span class="categoryName">{{ category?.name }}</span>
          </div>
        </div>                
        </div>
      </div>
    </div>
  </div>
</div>
</div>
